import { formatDistanceToNow, format, isAfter, subDays } from "date-fns";
import type { TrendingWindow } from "@/types";

/** "3 hours ago" style relative label. */
export function relativeTime(iso: string): string {
  try {
    return formatDistanceToNow(new Date(iso), { addSuffix: true });
  } catch {
    return iso;
  }
}

/** Locale-friendly absolute timestamp. */
export function absoluteTime(iso: string): string {
  try {
    return format(new Date(iso), "PP p");
  } catch {
    return iso;
  }
}

/** ISO date (yyyy-MM-dd) for date pickers. */
export function toDateInputValue(value: string | number | null): string {
  if (value === null) return "";
  try {
    return format(new Date(value), "yyyy-MM-dd");
  } catch {
    return "";
  }
}

export function windowToDays(window: TrendingWindow): number {
  switch (window) {
    case "24h":
      return 1;
    case "7d":
      return 7;
    case "30d":
      return 30;
  }
}

/** True if `iso` falls within the trending window ending now. */
export function withinWindow(iso: string, window: TrendingWindow): boolean {
  const cutoff = subDays(new Date(), windowToDays(window));
  try {
    return isAfter(new Date(iso), cutoff);
  } catch {
    return false;
  }
}
